// src/screens/AdminLogin.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Screen from '../Screen';
import '../Login.css'; // reuse same file (or make AdminLogin.css if you prefer)
import api from '../api';

import barterfiLogoLogin from '../assets/barterfi-logologin.png';
import backIcon from '../assets/backspace-icon.png';

export default function AdminLogin({ onLogin }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorBanner, setErrorBanner] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // ⏱️ Auto-hide errors
  useEffect(() => {
    if (!errorBanner) return;
    const t = setTimeout(() => setErrorBanner(''), 5000);
    return () => clearTimeout(t);
  }, [errorBanner]);

  const validateEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setErrorBanner('Please enter a valid email address.');
      return;
    }
    if (password.length < 6) {
      setErrorBanner('Password must be at least 6 characters.');
      return;
    }

    try {
      setIsLoading(true);
      const res = await api.post('/auth/login', { email, password });
      const user = res.data.user;

      localStorage.setItem('token', res.data.token);
      localStorage.setItem('barterfi_user', JSON.stringify(user));

      localStorage.removeItem('profilePosts');
      localStorage.removeItem('savedPosts');
      localStorage.removeItem('userPosts');

      onLogin(user);
      navigate('/home');
    } catch (err) {
      console.error('❌ Admin email login failed:', err);
      setErrorBanner(err.response?.data?.message || 'Login failed.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Screen>
      <div className="admin-login-wrap">
        <button className="admin-back-btn" onClick={() => navigate('/login')}>
          <img src={backIcon} alt="Back" />
        </button>

        <div className="admin-login-card">
          <img src={barterfiLogoLogin} alt="BarterFi Logo" className="admin-logo" />

          <h2 className="admin-title">Admin login</h2>

          {errorBanner && <div className="error-banner">{errorBanner}</div>}

          <form onSubmit={handleLogin} className="login-form">
            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button className="login-btn" type="submit" disabled={isLoading}>
              {isLoading ? 'Logging in…' : 'Log In'}
            </button>
          </form>

          <p className="admin-hint">
            This login is for internal testing accounts only.
          </p>
        </div>
      </div>
    </Screen>
  );
}
